import axios from 'axios';

  export default axios.create({
        baseURL: 'https://json.geoapi.pt/cp/',
    })
